/* ==========================================================================
   Casemira, fenêtre de l'offre (pop-up du mois)
   Casemira 28/10/2026 (offre de novembre), fenêtre v2 du lot R3-B
   --------------------------------------------------------------------------
   Balisage : snippets/casemira-offre-fenetre.liquid (rendu par la barre haute,
   toutes les pages, seulement pendant l'offre). Feuille :
   assets/casemira-offre-fenetre.css.

   OUVERTURE
     - clic sur le bandeau (assets/casemira-topbar.js appelle ouvrir()) ;
     - clic sur tout élément `[data-cm-offre-ouvrir]` de la page ;
     - clic sur un ancien lien `[data-open-newsletter-popup]` (la pop-up
       newsletter n'est pas rendue pendant l'offre : la fenêtre la remplace) ;
     - événement `cm-offre-ouvrir` sur `document` : émis par casemira-offre.js
       pour `?offre=1` et `#comment`, et par le panier avec
       `detail: { variante: 'panier' }` (variante SANS bloc e-mail) ;
       (31/10 : la bande du bas ne porte plus de formulaire en novembre, réglage
       `offre_fenetre_email` décoché ; tout ce qui concerne l'inscription ci-dessous
       reste inerte tant que `[data-cm-fenetre-mail]` est absent du balisage) ;
     - window.CM_OFFRE_FENETRE.ouvrir(declencheur, mode) depuis un script ;
     - l'ouverture AUTOMATIQUE, mécanique recopiée de assets/casemira-popup.js
       (voir plus bas, « La pop-up du mois »).
   FERMETURE : Échap, croix, clic ou toucher sur le voile,
     window.CM_OFFRE_FENETRE.fermer(). Le focus revient au déclencheur, muet
     au doigt (`cm-focus-muet`, retours 2 du 28/10).

   Retours 3 (maquette validée par Raphaël le 28/10 à 23h25) : plus de
   feuille du bas ni de glisser pour fermer ; fenêtre centrée partout. Le
   bloc e-mail et l'inscription reprennent EXACTEMENT ceux de la pop-up
   newsletter (voir « L'inscription »).

   POLITIQUE DES CALQUES (casemira-tokens.css) : `cm-over` sur <html> pendant
   l'ouverture, plus `cmo-open`, la marque de CE calque. À la fermeture,
   `cm-over` n'est retirée que si personne d'autre ne la revendique.
   Ouverte depuis le menu téléphone, la fenêtre se pose PAR-DESSUS le menu,
   qui reste ouvert ; l'Échap qui la ferme est retenu (le `keyup` de
   theme.js fermerait aussi le menu).

   SUIVI : `dataLayer.push({ event: 'cm_offre_fenetre', mode, periode })` à
   chaque ouverture, mode « auto », « manuel » ou « panier ». La pop-up
   newsletter d'avant ne poussait rien dans le dataLayer (vérifié le 28/10).

   Aucun texte face client ici : tout est dans le Liquid.
   ========================================================================== */
(function () {
  'use strict';

  if (window.CM_OFFRE_FENETRE) return;
  var d = document.getElementById('cm-offre-fenetre');
  if (!d) return;

  var racine = document.documentElement;
  var natif = typeof d.showModal === 'function';
  var declencheur = null;
  var ouverte = false;
  var enAttente = false;
  var enSortie = false;
  var echapPris = false;
  var bloc = d.querySelector('[data-cm-fenetre-mail]');
  var form = bloc ? bloc.querySelector('form') : null;
  var champ = form ? form.querySelector('input[name="contact[email]"]') : null;
  var erreur = form ? form.querySelector('[data-cm-newsletter-status]') : null;
  var succes = bloc ? bloc.querySelector('[data-cm-fenetre-succes]') : null;

  function reduit() {
    try {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (e) {
      return false;
    }
  }

  function offre() {
    return window.CM_OFFRE || null;
  }

  function periodeDuJour() {
    var O = offre();
    return (O && O.periode) || racine.getAttribute('data-periode') || '';
  }

  /* ── Mémoires partagées avec la pop-up newsletter ────────────────────────
     Mêmes clés que assets/casemira-popup.js : un visiteur qui a fermé la
     pop-up newsletter dans la session ne reçoit pas la fenêtre, et un inscrit
     ne la reçoit plus jamais d'elle-même. */
  var stockageOK = true;
  try {
    sessionStorage.setItem('_t', '1');
    sessionStorage.removeItem('_t');
  } catch (e) {
    stockageOK = false;
  }
  function dejaVue() {
    if (!stockageOK) return false;
    try { return !!sessionStorage.getItem('casemira_popup_session'); } catch (e) { return false; }
  }
  function marqueVue() {
    if (!stockageOK) return;
    try { sessionStorage.setItem('casemira_popup_session', '1'); } catch (e) { /* rien */ }
  }
  function inscrit() {
    try { return !!localStorage.getItem('casemira_popup_subscribed'); } catch (e) { return false; }
  }
  function marqueInscrit() {
    try { localStorage.setItem('casemira_popup_subscribed', '1'); } catch (e) { /* rien */ }
  }

  /* ── Focus muet au doigt (retours 2, 28/10) ──────────────────────────── */
  var modaliteClavier = false;

  function leveLeMuet() {
    var liste = document.querySelectorAll('.cm-focus-muet');
    for (var i = 0; i < liste.length; i++) liste[i].classList.remove('cm-focus-muet');
  }

  document.addEventListener('keydown', function (e) {
    if (e.metaKey || e.ctrlKey || e.altKey) return;
    modaliteClavier = true;
    leveLeMuet();
  }, true);

  ['pointerdown', 'mousedown', 'touchstart'].forEach(function (type) {
    document.addEventListener(type, function () {
      modaliteClavier = false;
    }, { capture: true, passive: true });
  });

  function rendMuet(el) {
    if (!el || modaliteClavier || !el.classList) return;
    el.classList.add('cm-focus-muet');
    var retire = function () {
      el.classList.remove('cm-focus-muet');
      el.removeEventListener('blur', retire);
    };
    el.addEventListener('blur', retire);
  }

  function focusDiscret(el) {
    if (!el || typeof el.focus !== 'function') return;
    rendMuet(el);
    try {
      el.focus({ preventScroll: true, focusVisible: modaliteClavier });
    } catch (e) {
      el.focus();
    }
  }

  /* Les autres surcouches qui posent `cm-over`, nommées une par une (liste de
     casemira-c6-loupe.js et casemira-avis-clients.js). */
  function quelquUnDAutreTientCmOver() {
    var h = racine.classList;
    var b = document.body ? document.body.classList : { contains: function () { return false; } };
    return (
      h.contains('cmk-open') ||
      h.contains('cmg-lock') ||
      h.contains('cmq-locked') ||
      h.contains('cmt-lock') ||
      b.contains('search-open') ||
      b.contains('search-is-open') ||
      b.contains('ca-lb-open') ||
      !!document.querySelector('menu-drawer[open]')
    );
  }

  /* La feuille est chargée sans bloquer la page : on l'attend avant d'ouvrir. */
  function quandFeuillePrete(suite) {
    var l = document.getElementById('cm-offre-fenetre-css');
    if (!l || l.sheet) {
      if (l && l.media !== 'all') l.media = 'all';
      suite();
      return;
    }
    var fait = false;
    function go() {
      if (fait) return;
      fait = true;
      if (l.media !== 'all') l.media = 'all';
      suite();
    }
    l.addEventListener('load', go);
    l.addEventListener('error', go);
    setTimeout(go, 2000);
  }

  function jouer() {
    d.classList.remove('cm-fenetre--joue');
    if (reduit()) return;
    /* Relecture de la mise en page entre le retrait et la pose : les
       animations repartent de zéro à chaque ouverture. */
    void d.offsetWidth;
    d.classList.add('cm-fenetre--joue');
  }

  function suivre(mode) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'cm_offre_fenetre', mode: mode, periode: periodeDuJour() });
    } catch (e) { /* rien */ }
  }

  /* ── Compte à rebours heures et minutes ─────────────────────────────────
     Tous les `[data-cm-rebours-hms]` AFFICHÉS de la page (snippet
     casemira-offre-compte avec `cm_hms`), vers la fin de l'événement du jour
     (CM_OFFRE.finEvenement, horloge simulée comprise). Deux blocs, heures et
     minutes, sans secondes (Raphaël, 28/10 23h25) ; les heures ne passent pas
     en jours. Mis à jour au chargement, à l'ouverture, puis calé sur la
     minute pleine ; éléments masqués compris (pastille du menu). */
  function majHms() {
    var O = offre();
    if (!O || typeof O.maintenant !== 'function') return;
    var liste = document.querySelectorAll('[data-cm-rebours-hms]');
    for (var i = 0; i < liste.length; i++) {
      var n = liste[i];
      /* Tous les éléments, masqués compris (29/10) : la pastille du menu
         téléphone n'est visible qu'une fois le menu ouvert, et rien ne
         signale cette ouverture ici. Écrire deux nombres dans un élément
         caché ne coûte rien ; tous visent la même fin. */
      var v = n.getAttribute('data-cm-rebours-hms');
      var fin = !v || v === 'evenement' ? O.finEvenement : v === 'offre' ? O.finOffre : new Date(Date.parse(v));
      if (!fin || isNaN(fin.getTime())) continue;
      var reste = Math.max(0, Math.floor((fin.getTime() - O.maintenant()) / 60000));
      var valeurs = {
        heures: String(Math.floor(reste / 60)),
        minutes: String(reste % 60)
      };
      var blocs = n.querySelectorAll('[data-unite]');
      for (var j = 0; j < blocs.length; j++) {
        var champV = blocs[j].querySelector('[data-cm-valeur]');
        var texte = valeurs[blocs[j].getAttribute('data-unite')];
        if (champV && texte != null && champV.textContent !== texte) champV.textContent = texte;
      }
    }
  }
  var minuteHms = null;
  function planifieHms() {
    clearTimeout(minuteHms);
    var O = offre();
    var maintenant = O && typeof O.maintenant === 'function' ? O.maintenant() : Date.now();
    minuteHms = setTimeout(function () {
      if (document.visibilityState !== 'hidden') majHms();
      planifieHms();
    }, 60000 - (maintenant % 60000) + 250);
  }
  planifieHms();
  /* Choix A de Raphaël (29/10) : la pastille de la fiche et du menu porte
     elle aussi des `[data-cm-rebours-hms]`, visibles dès le chargement. Une
     première écriture dès que l'offre est prête (jusqu'ici seules
     l'ouverture et la minute pleine écrivaient : cases vides pendant une
     minute), et une autre à chaque changement de période. */
  if (offre()) majHms();
  else document.addEventListener('cm-offre-prete', function () { majHms(); }, { once: true });
  document.addEventListener('cm-offre-periode', function () { majHms(); });
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') {
      majHms();
      planifieHms();
    }
  });

  /* ── Ouvrir, fermer ───────────────────────────────────────────────────── */
  function ouvrir(source, mode) {
    if (ouverte || enAttente) return;
    var O = offre();
    if (O && O.actif === false) return;
    mode = mode || 'manuel';
    declencheur = source && source.nodeType === 1 ? source : document.activeElement;
    echapPris = false;
    enAttente = true;
    /* Toute ouverture compte comme vue : plus d'ouverture automatique ensuite
       dans la session (même clé que la pop-up newsletter). */
    marqueVue();
    arreteLesDeclencheurs();
    quandFeuillePrete(function () {
      enAttente = false;
      if (ouverte) return;
      ouverte = true;
      d.classList.toggle('cm-fenetre--panier', mode === 'panier');
      racine.classList.add('cmo-open');
      racine.classList.add('cm-over');
      if (O && typeof O.majMontants === 'function') {
        try { O.majMontants(d); } catch (e) { /* rien */ }
      }
      if (O && typeof O.majRebours === 'function') O.majRebours();
      majHms();
      if (natif) {
        try {
          d.showModal();
        } catch (e) {
          d.setAttribute('open', '');
        }
      } else {
        d.setAttribute('open', '');
      }
      d.scrollTop = 0;
      majHms();
      jouer();
      var fermer = d.querySelector('[data-cm-fenetre-fermer]');
      if (!natif && fermer) focusDiscret(fermer);
      /* `showModal` a posé le focus sur la croix : pas de contour au doigt. */
      else if (d.contains(document.activeElement)) rendMuet(document.activeElement);
      if (mode !== 'retour') suivre(mode);
    });
  }

  function apresFermeture() {
    if (!ouverte) return;
    ouverte = false;
    enSortie = false;
    d.classList.remove('cm-fenetre--joue', 'cm-fenetre--sortie');
    racine.classList.remove('cmo-open');
    if (!quelquUnDAutreTientCmOver()) racine.classList.remove('cm-over');
    var cible = declencheur;
    declencheur = null;
    if (cible && cible.focus && document.contains(cible) && cible !== document.body) {
      focusDiscret(cible);
    }
  }

  function fermerTout() {
    if (natif && d.open) {
      d.close();
      return;
    }
    d.removeAttribute('open');
    apresFermeture();
  }

  /* Fermeture animée : `cm-fenetre--sortie` (la boîte et le voile s'effacent),
     puis `close()`. Filet de 400 ms si `animationend` ne vient pas. */
  function fermer() {
    if (!ouverte || enSortie) return;
    if (!natif || reduit()) {
      fermerTout();
      return;
    }
    enSortie = true;
    var fait = false;
    function fin(e) {
      if (e && e.target !== d) return;
      if (fait) return;
      fait = true;
      d.removeEventListener('animationend', fin);
      fermerTout();
    }
    d.addEventListener('animationend', fin);
    d.classList.add('cm-fenetre--sortie');
    setTimeout(fin, 400);
  }

  d.addEventListener('close', apresFermeture);

  d.addEventListener('cancel', function (e) {
    e.preventDefault();
    echapPris = true;
    fermer();
  });

  d.addEventListener('keydown', function (e) {
    if (!natif && (e.key === 'Escape' || e.key === 'Esc')) {
      e.preventDefault();
      echapPris = true;
      fermer();
    }
  });

  /* Le relâchement de l'Échap qui a fermé la fenêtre ne va pas plus loin :
     le menu téléphone (theme.js, `keyup` sur document) se fermerait aussi. */
  window.addEventListener('keyup', function (e) {
    if (!echapPris || (e.key !== 'Escape' && e.key !== 'Esc')) return;
    echapPris = false;
    e.stopImmediatePropagation();
  }, true);

  d.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-cm-fenetre-fermer]')) fermer();
  });

  /* Clic ou toucher sur le voile : le clic sur `::backdrop` arrive au
     <dialog> lui-même, HORS de son rectangle, et seulement si le geste a
     COMMENCÉ dehors (une sélection glissée hors de la boîte ne ferme rien). */
  function horsBoite(e) {
    var r = d.getBoundingClientRect();
    return e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom;
  }
  var departSurFond = false;
  d.addEventListener('pointerdown', function (e) {
    departSurFond = e.target === d && horsBoite(e);
  });
  d.addEventListener('click', function (e) {
    if (e.target === d && departSurFond && horsBoite(e)) fermer();
    departSurFond = false;
  });

  /* Tout élément `[data-cm-offre-ouvrir]` de la page (un lien garde son
     adresse en repli sans script : `#comment` ou `?offre=1`). Un ancien lien
     de la pop-up newsletter ouvre la fenêtre : la pop-up n'existe pas pendant
     l'offre (capture : l'écouteur de la barre haute ne le voit pas). */
  document.addEventListener('click', function (e) {
    var el = e.target.closest ? e.target.closest('[data-cm-offre-ouvrir]') : null;
    if (!el) return;
    e.preventDefault();
    ouvrir(el, 'manuel');
  });
  window.addEventListener('click', function (e) {
    var el = e.target.closest ? e.target.closest('[data-open-newsletter-popup]') : null;
    if (!el || document.querySelector('subscription-popup[id^="SubscriptionModal"]')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    ouvrir(el, 'manuel');
  }, true);

  document.addEventListener('cm-offre-ouvrir', function (e) {
    var detail = (e && e.detail) || {};
    ouvrir(null, detail.variante === 'panier' ? 'panier' : 'manuel');
  });

  /* Le jour bascule pendant que la fenêtre est ouverte (minuit) : les textes
     suivent seuls (data-cm-si), les montants sont relus. */
  document.addEventListener('cm-offre-periode', function (e) {
    var p = e.detail && e.detail.periode;
    if (p === 'decembre') {
      fermer();
      arreteLesDeclencheurs();
      return;
    }
    var O = offre();
    if (O && typeof O.majMontants === 'function') {
      try { O.majMontants(d); } catch (err) { /* rien */ }
    }
  });

  /* ══ La pop-up du mois : ouverture automatique ═══════════════════════════
     Mécanique de assets/casemira-popup.js, délais raccourcis (voir plus bas) : 8 s
     après l'arrivée ; ou, passées 3 s, remontée de 400 px après
     être descendu de 600 px, 45 s d'inactivité, sortie de la souris par le
     haut (ordinateur), retour sur l'onglet (téléphone). Une fois par session,
     jamais pour un inscrit, jamais par-dessus un calque (elle attend sa
     fermeture puis s'ouvre), jamais en décembre, jamais dans l'éditeur, jamais
     sur les gabarits hors liste ni sur une page de conditions
     (`data-cm-auto`, décidé par le Liquid), jamais si `?offre=1` ou
     `#comment` l'a déjà ouverte. */
  /* Raphaël, 29/10 11h51 : cette fenêtre EXPLIQUE l'offre promise par le
     bandeau, elle ne quémande pas un e-mail ; un visiteur qui ne comprend pas
     le « comment » peut partir. Ouverture automatique à 8 s (18 s pour la
     pop-up newsletter), et les gestes de sortie (souris par le haut, remontée
     de page, retour sur l'onglet) dès 3 s. Une fois par session, inchangé. */
  var MIN_TIME_DEFAULT = 3;
  var MIN_TIME_RETURN = 3;
  var AUTO_OPEN_MS = 8000;
  var SCROLL_UP_THRESHOLD = 400;
  var MIN_SCROLL_DEPTH = 600;
  var INACTIVITY_MS = 45000;
  var DELAI_APRES_CALQUE = 1200;

  var entryTime = Date.now();
  var maxY = 0;
  var lastY = 0;
  var upDist = 0;
  var idleTimer = null;
  var autoTimer = null;
  var wasHidden = false;
  var declencheursArmes = false;
  var enFile = false;
  var dejaAuto = false;

  function autoPermise() {
    if (d.getAttribute('data-cm-auto') !== 'oui') return false;
    if (/\/(policies|account|search|checkouts?)(\/|$)/.test(location.pathname)) return false;
    var O = offre();
    if (O && (O.actif === false || O.periode === 'decembre')) return false;
    if (racine.getAttribute('data-periode') === 'decembre') return false;
    if (O && O.ouvertureDemandee) return false;
    /* 30/10 (Raphaël, 11 h 24) : un inscrit n'est plus exclu de l'ouverture
       automatique. Le drapeau `casemira_popup_subscribed` venait de la pop-up
       newsletter : quelqu'un inscrit en septembre sur cet appareil n'a jamais
       vu l'offre de novembre, il doit la voir comme les autres. (31/10 : plus de
       bloc e-mail en novembre, la fenêtre explique seulement.) */
    if (dejaVue()) return false;
    return true;
  }

  function unCalqueEstOuvert() {
    if (racine.classList.contains('cm-over') || quelquUnDAutreTientCmOver()) return true;
    var dialogues = document.querySelectorAll('dialog[open]');
    for (var i = 0; i < dialogues.length; i++) {
      if (dialogues[i] !== d) return true;
    }
    return false;
  }

  /* Un calque vit (tiroir panier, menu, filtres...) : la fenêtre prend son
     tour et s'ouvre 1,2 s après sa fermeture, une fois. */
  function prendSonTour() {
    if (enFile) return;
    enFile = true;
    var veille = setInterval(function () {
      if (unCalqueEstOuvert()) return;
      clearInterval(veille);
      setTimeout(function () {
        enFile = false;
        ouvrirAuto(0);
      }, DELAI_APRES_CALQUE);
    }, 400);
  }

  function ouvrirAuto(minTime) {
    if (minTime == null) minTime = MIN_TIME_DEFAULT;
    if (dejaAuto || ouverte || enAttente) return;
    if (!autoPermise()) {
      arreteLesDeclencheurs();
      return;
    }
    if ((Date.now() - entryTime) / 1000 < minTime) return;
    if (unCalqueEstOuvert()) {
      prendSonTour();
      return;
    }
    dejaAuto = true;
    ouvrir(null, 'auto');
  }

  function onMouse(e) {
    if (e.clientY <= 5 && !e.relatedTarget) ouvrirAuto();
  }
  function onVis() {
    if (document.visibilityState === 'hidden') {
      wasHidden = true;
    } else if (wasHidden) {
      wasHidden = false;
      setTimeout(function () { ouvrirAuto(MIN_TIME_RETURN); }, 800);
    }
  }
  function onScroll() {
    var y = window.pageYOffset || racine.scrollTop;
    if (y > maxY) maxY = y;
    if (y < lastY) upDist += lastY - y;
    else upDist = 0;
    if (maxY >= MIN_SCROLL_DEPTH && upDist >= SCROLL_UP_THRESHOLD) ouvrirAuto();
    lastY = y;
    resetIdle();
  }
  function resetIdle() {
    if (idleTimer) clearTimeout(idleTimer);
    idleTimer = setTimeout(function () { ouvrirAuto(); }, INACTIVITY_MS);
  }
  function onAct() {
    resetIdle();
  }

  function armeLesDeclencheurs() {
    if (declencheursArmes || !autoPermise()) return;
    declencheursArmes = true;
    var tactile = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    if (tactile) {
      document.addEventListener('visibilitychange', onVis);
      window.addEventListener('scroll', onScroll, { passive: true });
      document.addEventListener('touchstart', onAct, { passive: true });
      document.addEventListener('touchmove', onAct, { passive: true });
    } else {
      document.addEventListener('mouseout', onMouse);
      document.addEventListener('mousemove', onAct, { passive: true });
      document.addEventListener('keydown', onAct, { passive: true });
    }
    document.addEventListener('click', onAct, { passive: true });
    resetIdle();
    autoTimer = setTimeout(function () { ouvrirAuto(0); }, AUTO_OPEN_MS);
  }

  function arreteLesDeclencheurs() {
    if (idleTimer) clearTimeout(idleTimer);
    if (autoTimer) clearTimeout(autoTimer);
    idleTimer = null;
    autoTimer = null;
    if (!declencheursArmes) return;
    declencheursArmes = false;
    document.removeEventListener('mouseout', onMouse);
    document.removeEventListener('visibilitychange', onVis);
    window.removeEventListener('scroll', onScroll);
    document.removeEventListener('touchstart', onAct);
    document.removeEventListener('touchmove', onAct);
    document.removeEventListener('mousemove', onAct);
    document.removeEventListener('keydown', onAct);
    document.removeEventListener('click', onAct);
  }

  /* ══ L'inscription ═══════════════════════════════════════════════════════
     Reprise de assets/casemira-popup.js (formulaire `CasemiraPopupForm`) :
     - langues du relais (toutes sauf le français, liste
       `window.cmNewsletterRelais.popup` de casemira-newsletter-routing.js) :
       ce script de routage reconnaît le formulaire à son identifiant et
       l'envoie au relais Render (liste Klaviyo de la langue), puis soumet le
       formulaire Shopify ; rien à faire ici que le contrôle de l'adresse ;
     - français : identification Klaviyo (klaviyo.identify, sinon _learnq),
       inscription par `client/subscriptions` (company_id TM6pHJ, liste
       SiJZYk, mêmes propriétés ; source « fenetre_offre_novembre »), puis
       soumission du formulaire Shopify `customer` (création du client, la
       page revient sur `?customer_posted=true`), au plus tard 5 s après.
     Avant l'envoi : `casemira_popup_subscribed` et la trace `cmp_pending`
     (session ET cookie de première partie, dix minutes). Au retour de
     Shopify, la trace autorise l'état de succès : la fenêtre se rouvre avec
     « C'est envoyé. L'offre arrive dans votre boîte. » à la place du bloc. */
  var TRACE = 'cmp_pending';
  var RELAIS_REPLI = ['de', 'nl', 'en', 'it', 'es', 'pt', 'cs', 'sk', 'da', 'hu', 'hr', 'ro', 'sv', 'fi', 'el', 'bg', 'sl', 'lv', 'et', 'lt'];

  function poseLaTrace() {
    try { sessionStorage.setItem(TRACE, '1'); } catch (e) { /* rien */ }
    try { document.cookie = TRACE + '=1; path=/; max-age=600; SameSite=Lax'; } catch (e) { /* rien */ }
  }
  function litLaTrace() {
    try { if (sessionStorage.getItem(TRACE)) return true; } catch (e) { /* rien */ }
    try { if (document.cookie.indexOf(TRACE + '=1') > -1) return true; } catch (e) { /* rien */ }
    return false;
  }
  function effaceLaTrace() {
    try { sessionStorage.removeItem(TRACE); } catch (e) { /* rien */ }
    try { document.cookie = TRACE + '=; path=/; max-age=0; SameSite=Lax'; } catch (e) { /* rien */ }
  }

  function langue() {
    return (racine.lang || '').toLowerCase().split('-')[0];
  }
  function parLeRelais() {
    var liste = (window.cmNewsletterRelais && window.cmNewsletterRelais.popup) || RELAIS_REPLI;
    return liste.indexOf(langue()) !== -1;
  }

  function montreErreur(texte) {
    if (!erreur) return;
    erreur.textContent = texte || erreur.getAttribute('data-cm-erreur') || '';
    if (champ) champ.setAttribute('aria-invalid', 'true');
  }
  function effaceErreur() {
    if (erreur) erreur.textContent = '';
    if (champ) champ.removeAttribute('aria-invalid');
  }
  function montreSucces() {
    if (!bloc || !succes) return;
    bloc.setAttribute('data-etat', 'succes');
    succes.hidden = false;
  }

  function adresseValide(v) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v);
  }

  if (champ) {
    champ.addEventListener('input', function () {
      if (champ.getAttribute('aria-invalid') === 'true') effaceErreur();
    });
  }

  var envoiEnCours = false;

  /* En capture sur `window` : passe AVANT le script de routage (capture sur
     `document`), pour que l'adresse invalide donne le message sous le champ
     dans toutes les langues, sans la bulle du navigateur. */
  /* 30/10 (mail après la fenêtre, demande de la session offres) : une étiquette
     de PÉRIODE en plus des étiquettes fixes, `fenetre-offre-<periode>`, pour
     que Klaviyo (propriété « Shopify Tags ») déclenche le bon flux. Calculée
     par la tête (`CM_OFFRE_TETE`, horloge simulée comprise), à la minute : le
     Liquid peut être en cache, l'input caché est donc réécrit au chargement,
     à chaque bascule de période et juste avant l'envoi. Du 21 0 h au 23 0 h,
     tout inscrit de la fenêtre reçoit `acces-anticipe`, jeton ou pas. */
  var NOMS_ETIQUETTE = { socle: 'black-month', black_week: 'black-week', black_friday: 'black-friday', black_weekend: 'black-friday-prolonge', cyber_monday: 'cyber-monday' };
  function etiquettePeriode() {
    var T = window.CM_OFFRE_TETE;
    if (!T || typeof T.periode !== 'function') return '';
    var t = T.maintenant(), B = T.bornes || {};
    if (!isNaN(B.acces) && !isNaN(B.black_week) && t >= B.acces && t < B.black_week && T.periode(t) !== 'decembre') return 'acces-anticipe';
    return NOMS_ETIQUETTE[T.periode(t)] || '';
  }
  function majEtiquette() {
    if (!form) return;
    var cache = form.querySelector('input[name="contact[tags]"]');
    if (!cache) return;
    var base = cache.getAttribute('data-cm-tags-base');
    if (base === null) { base = cache.value; cache.setAttribute('data-cm-tags-base', base); }
    var p = etiquettePeriode();
    cache.value = p ? base + ',fenetre-offre-' + p : base;
  }
  majEtiquette();
  document.addEventListener('cm-offre-periode', majEtiquette);

  /* 30/10 (session offres, 10 h 29) : le formulaire client Shopify n'ajoute
     AUCUNE étiquette à un client existant et dit quand même « c'est envoyé »
     (test de Raphaël à 10 h 23, client et profil Klaviyo inchangés). Le seul
     geste qui écrit à chaque clic, pour tout profil et toutes langues, est un
     ÉVÉNEMENT Klaviyo : métrique « Offre demandée », émise avant les appels
     existants, dans les deux chemins. `keepalive` : la page part vers Shopify
     juste après, la requête doit survivre. Le flux Klaviyo par période se
     branche dessus (propriété `periode`). */
  function emetOffreDemandee(email) {
    try {
      var etiquette = etiquettePeriode();
      if (!etiquette || !email) return;
      var T = window.CM_OFFRE_TETE, O = window.CM_OFFRE || {};
      /* `CM_OFFRE.montants` est déjà le jeu de la période courante, en centimes
         (casemira-offre.js, `appliquer`). */
      var m = Array.isArray(O.montants) ? O.montants : [];
      var max = m.length ? Math.max.apply(null, m) / 100 : (typeof O.montantMax === 'number' ? O.montantMax / 100 : null);
      var props = {
        periode: etiquette.replace(/-/g, '_'),
        langue: langue(),
        pays: racine.getAttribute('data-delivery-country') || '',
        devise: O.devise || '',
        montant_max: max,
        page: window.location.pathname,
        source: 'fenetre_offre_novembre',
        horloge_simulee: !!(T && T.test)
      };
      fetch('https://a.klaviyo.com/client/events/?company_id=TM6pHJ', {
        method: 'POST',
        keepalive: true,
        headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
        body: JSON.stringify({
          data: {
            type: 'event',
            attributes: {
              properties: props,
              metric: { data: { type: 'metric', attributes: { name: 'Offre demandée' } } },
              profile: { data: { type: 'profile', attributes: { email: email } } },
              unique_id: email + '|' + props.periode + '|' + Date.now()
            }
          }
        })
      }).catch(function () { /* rien : l'inscription continue */ });
    } catch (err) { /* rien */ }
  }

  window.addEventListener('submit', function (e) {
    if (!form || e.target !== form) return;
    var email = champ ? champ.value.trim() : '';
    if (!adresseValide(email)) {
      e.preventDefault();
      e.stopImmediatePropagation();
      montreErreur();
      if (champ) champ.focus();
      return;
    }
    effaceErreur();
    marqueVue();
    majEtiquette();
    emetOffreDemandee(email);

    if (parLeRelais()) {
      /* Le script de routage prend la main (relais, puis formulaire Shopify).
         S'il manquait, la soumission native part vers Shopify : on pose ce
         qu'il aurait posé, pour l'état de succès au retour. */
      if (!window.cmNewsletterRoutingReady) {
        marqueInscrit();
        poseLaTrace();
      }
      return;
    }

    e.preventDefault();
    e.stopImmediatePropagation();
    if (envoiEnCours) return;
    envoiEnCours = true;
    var bouton = form.querySelector('[type="submit"]');
    if (bouton) bouton.disabled = true;

    marqueInscrit();
    poseLaTrace();

    var envoye = false;
    function soumettreShopify() {
      if (envoye) return;
      envoye = true;
      HTMLFormElement.prototype.submit.call(form);
    }

    var urlParams = new URLSearchParams(window.location.search);
    var lastCollection = '';
    try {
      var pathMatch = document.referrer.match(/\/collections\/([^\/\?]+)/);
      lastCollection = pathMatch ? pathMatch[1] : '';
    } catch (err) { /* rien */ }

    var properties = {
      acquisition_source: urlParams.get('utm_source') || 'direct',
      acquisition_medium: urlParams.get('utm_medium') || '',
      acquisition_campaign: urlParams.get('utm_campaign') || '',
      popup_signup_at: new Date().toISOString(),
      last_collection_viewed: lastCollection,
      signup_page: window.location.pathname,
      signup_source: 'fenetre_offre_novembre'
    };

    try {
      if (window.klaviyo && typeof window.klaviyo.identify === 'function') {
        window.klaviyo.identify({ email: email });
      } else if (window._learnq) {
        window._learnq.push(['identify', { '$email': email }]);
      }
    } catch (err) { /* rien */ }

    try {
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=TM6pHJ', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'revision': '2024-10-15'
        },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'fenetre_offre_novembre',
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: email,
                    properties: properties
                  }
                }
              }
            },
            relationships: {
              list: {
                data: { type: 'list', id: 'SiJZYk' }
              }
            }
          }
        })
      })
        .then(function () { soumettreShopify(); })
        .catch(function () { soumettreShopify(); });
    } catch (err) {
      soumettreShopify();
    }
    setTimeout(soumettreShopify, 5000);
  }, true);

  /* Retour de Shopify après l'inscription (fenêtre, ou bloc newsletter du
     pied : même trace). Le message vert par défaut du thème ne doit jamais
     coexister avec l'état de succès. */
  function retourDInscription() {
    if (window.location.search.indexOf('customer_posted') === -1) return false;
    if (!litLaTrace()) return false;
    effaceLaTrace();
    function retireLesModalesDuTheme() {
      var liste = document.querySelectorAll('.modal--newsletter-alert, [id*="NewsletterAlertModal"], [id^="Newsletter-success--"]');
      for (var i = 0; i < liste.length; i++) {
        var m = liste[i];
        m.removeAttribute('open');
        m.removeAttribute('active');
        m.setAttribute('hidden', '');
        m.style.display = 'none';
      }
    }
    retireLesModalesDuTheme();
    setTimeout(retireLesModalesDuTheme, 200);
    setTimeout(retireLesModalesDuTheme, 600);
    setTimeout(retireLesModalesDuTheme, 1200);
    montreSucces();
    try {
      var u = new URL(window.location.href);
      u.searchParams.delete('customer_posted');
      u.hash = '';
      window.history.replaceState(null, '', u.pathname + u.search);
    } catch (e) { /* rien */ }
    ouvrir(null, 'retour');
    return true;
  }

  /* Erreur rendue par Shopify au retour (formulaire refusé) : la fenêtre se
     rouvre sur le bloc, message sous le champ. */
  function retourEnErreur() {
    if (!erreur || !erreur.hasAttribute('data-cm-erreur-serveur')) return false;
    if (champ) champ.setAttribute('aria-invalid', 'true');
    ouvrir(null, 'manuel');
    return true;
  }

  window.CM_OFFRE_FENETRE = {
    ouvrir: ouvrir,
    fermer: fermer,
    estOuverte: function () {
      return ouverte;
    },
    majHms: majHms,
    element: d
  };

  function demarrer() {
    if (retourDInscription() || retourEnErreur()) return;
    /* Script arrivé après `cm-offre-prete` : l'événement d'ouverture est
       déjà parti, on lit la demande. */
    var O = offre();
    if (O && O.prete && O.ouvertureDemandee) {
      ouvrir(null, 'manuel');
      return;
    }
    armeLeDeclencheursQuandPret();
  }

  function armeLeDeclencheursQuandPret() {
    if (offre()) {
      armeLesDeclencheurs();
      return;
    }
    document.addEventListener('cm-offre-prete', function () { armeLesDeclencheurs(); }, { once: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer);
  else demarrer();
})();
